import { useEffect, useState } from "react";
import { MousePointerClick, RefreshCw } from "lucide-react";
import api from "@/lib/api";
import { useSortable, SortableTh } from "@/lib/sort";

const fmtDate = (s) => (s ? new Date(s).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export function FarmanalizaClicks() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/farmanaliza-clicks").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const { sorted, sortKey, direction, toggle } = useSortable(rows || [], "last_at", "desc", "farmanaliza-clicks");
  return (
    <section className="mt-10" data-testid="farmanaliza-clicks">
      <div className="flex items-center gap-3">
        <h2 className="font-display text-lg font-bold flex items-center gap-2"><MousePointerClick className="h-5 w-5 text-sky-600" /> Quién pincha «¿Problemas de stock o ventas?»</h2>
        <button onClick={load} data-testid="farmanaliza-clicks-refresh" className="inline-flex items-center gap-1 text-xs text-slate-600 border border-slate-300 rounded-md px-2 py-1 hover:bg-slate-50"><RefreshCw className="h-3 w-3" /> Actualizar</button>
      </div>
      <p className="text-xs text-slate-500 mt-1">Farmacias que han abierto la web de Farmanaliza desde el menú o desde el aviso de «Stock que no vendes».</p>
      <div className="mt-3 border border-slate-200 rounded-lg overflow-x-auto bg-white">
        {rows === null ? <div className="p-4 text-sm text-slate-500">Cargando…</div> : !rows.length ? (
          <div className="p-4 text-sm text-slate-500" data-testid="farmanaliza-clicks-empty">Todavía ninguna farmacia ha pinchado.</div>
        ) : (
          <table className="w-full text-xs" data-testid="farmanaliza-clicks-table">
            <thead><tr className="bg-slate-100 text-slate-600">
              <SortableTh k="pharmacy_name" sortKey={sortKey} direction={direction} toggle={toggle}>Farmacia</SortableTh>
              <SortableTh k="email" sortKey={sortKey} direction={direction} toggle={toggle}>Email</SortableTh>
              <SortableTh k="license_code" sortKey={sortKey} direction={direction} toggle={toggle}>Licencia</SortableTh>
              <SortableTh k="clicks" sortKey={sortKey} direction={direction} toggle={toggle} align="right">Veces</SortableTh>
              <SortableTh k="menu" sortKey={sortKey} direction={direction} toggle={toggle} align="right">Menú</SortableTh>
              <SortableTh k="stalled" sortKey={sortKey} direction={direction} toggle={toggle} align="right">Stock parado</SortableTh>
              <SortableTh k="first_at" sortKey={sortKey} direction={direction} toggle={toggle}>Primera vez</SortableTh>
              <SortableTh k="last_at" sortKey={sortKey} direction={direction} toggle={toggle}>Última vez</SortableTh>
            </tr></thead>
            <tbody>
              {sorted.map((r) => (
                <tr key={r.user_id} className="border-t border-slate-100" data-testid={`farmanaliza-click-row-${r.user_id}`}>
                  <td className="px-3 py-1.5 font-medium">{r.pharmacy_name || "—"}</td>
                  <td className="px-3 py-1.5 text-slate-600">{r.email}</td>
                  <td className="px-3 py-1.5 font-mono text-slate-500">{r.license_code || "—"}</td>
                  <td className="px-3 py-1.5 text-right font-semibold">{r.clicks}</td>
                  <td className="px-3 py-1.5 text-right">{r.menu}</td>
                  <td className="px-3 py-1.5 text-right">{r.stalled}</td>
                  <td className="px-3 py-1.5">{fmtDate(r.first_at)}</td>
                  <td className="px-3 py-1.5">{fmtDate(r.last_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </section>
  );
}
